import { Link } from "react-router-dom";
import { Star, MapPin } from "lucide-react";
import { ResponsiveImage } from "@/components/site/ResponsiveImage";
import { useLang } from "@/context/LangContext";


export const Stars = ({ value, size = "h-4 w-4" }) => (
  <span className="inline-flex">
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />)}
  </span>
);

export const RatingPill = ({ rating, count }) => {
  const { t, money, tr } = useLang();
  return (
    <span className="inline-flex items-center gap-1 text-sm">
      <Star className="h-4 w-4 fill-amber-400 text-amber-400" />
      <b className="text-slate-900">{Number(rating).toFixed(1)}</b>
      {count != null && <span className="text-slate-500">({count.toLocaleString()} {t("reviews")})</span>}
    </span>
  );
};

export default function DestinationCard({ d, i = 0 }) {
  const { t, money, tr } = useLang();
  return (
    <Link to={`/destinations/${d.slug}`} data-testid={`destination-card-${d.slug}`} className="destination-card group block min-w-0 fade-up" style={{ animationDelay: `${i * 60}ms` }}>
      <div className="relative overflow-hidden rounded-2xl aspect-[4/3] bg-slate-100">
        <ResponsiveImage src={d.image} alt={d.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <span className="absolute left-3 top-3 rounded-full bg-white/95 px-3 py-1 text-xs font-bold text-slate-800 shadow">{t(`cat_${d.category}`)}</span>
      </div>
      <div className="mt-3 space-y-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-bold text-slate-900 leading-snug">{d.name}</h3>
          <RatingPill rating={d.rating} />
        </div>
        <p className="flex items-center gap-1 text-sm text-slate-500"><MapPin className="h-3.5 w-3.5" />{d.city}</p>
        <p className="text-sm text-slate-500">{d.review_count.toLocaleString()} {t("reviews")} · <b className="text-slate-900">{d.price ? money(d.price, d.city_slug) : t("free")}</b></p>
      </div>
    </Link>
  );
}
